module.exports = __webpack_public_path__ + "assets/img/54a.200dac77.jpg";